import {
    drawerStore,
    MainButton,
    MobileDrawerFrame,
    Typography,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { ItinTagsList } from '../../../../../feat/components/itinTagsList'
import i18n from '../../../../../i18n/i18next'
import { useBoundStore } from '../../../../../state/bound.store'

type TCarouselItineraryTags = { id?: string; tags: number[] }
export const CarouselItineraryTags: FC<TCarouselItineraryTags> = ({
    id,
    tags,
}) => {
    const { allTags } = useBoundStore(
        useShallow((s) => {
            return {
                allTags: s.orgConfig?.itinTags ?? [],
            }
        })
    )

    const tagObjs = useMemo(() => {
        const tagObjs = allTags.filter((testTag) => {
            return tags?.includes(testTag.id)
        })
        return tagObjs
    }, [allTags, tags])

    if (!tags) return null

    return (
        <Box
            id={id}
            sx={{
                display: 'grid',
                gridAutoFlow: 'column',
                height: '6px',
                width: 'max-content',
                gap: '4px',
            }}
            onClick={() => {
                drawerStore().openDrawer({
                    node: (
                        <MobileDrawerFrame
                            title={i18n.t('home.itinTags')}
                            minHeight="30vh"
                        >
                            <Box
                                display={'grid'}
                                gridTemplateRows={'auto auto 1fr auto'}
                            >
                                <Box height={'16px'} />
                                <Typography
                                    id="itinerary-tag-drawer-current-itinerary-name"
                                    variant="bodyBold"
                                    align="center"
                                >
                                    {useBoundStore.getState().getEventInfoV2()
                                        ?.data?.title ?? ''}
                                </Typography>
                                <Box
                                    display={'grid'}
                                    justifyItems={'center'}
                                    alignItems={'center'}
                                >
                                    <ItinTagsList tagIds={tags} />
                                </Box>
                                <MainButton
                                    id="itinerary-tag-drawer-done-button"
                                    variant="secondary"
                                    text={i18n.t('general.done')}
                                    onClick={() => {
                                        drawerStore().closeDrawer()
                                    }}
                                />
                            </Box>
                        </MobileDrawerFrame>
                    ),
                    onBackdropClick: () => drawerStore().closeDrawer(),
                })
            }}
        >
            {tagObjs.map((tagObj) => {
                if (!tagObj || !tagObj.colour) {
                    return null
                }
                return (
                    <Box
                        key={tagObj.name}
                        sx={{
                            height: '6px',
                            width: '32px',
                            backgroundColor: tagObj.colour,
                            borderRadius: '6px',
                        }}
                    ></Box>
                )
            })}
        </Box>
    )
}
